import page from '../../../../constants/pages/page';
export const sortedKeyMap = { created_at_time: 'created_at', 'status.description': 'id_transfer_status' };
export const defaultSorted = [{ dataField: 'created_at', order: 'desc' }];
export const initialFilter = {
    filters: null,
    sortOrder: 'desc',
    sortField: 'created_at',
    pageNumber: page.pageNumber,
    pageSize: localStorage.getItem('sizePerPage') || page.pageSize
};

export const initialClientGeneral = {
    bornDate: '',
    civilStatus: '',
    cuil: '',
    dni: '',
    email: '',
    gender: '',
    nationality: '',
    occupation: '',
    telephone: '',
    devices: []
};

export const initialClientAddress = [
    {
        id: 0,
        country: '',
        state: '',
        city: '',
        street: '',
        floor: '',
        department: ''
    }
];
export const initialClientEmail = [
    {
        id: 0,
        email: '',
        created_at: new Date(),
        updated_at: new Date(),
        status: 0,
    }
];
export const initialTelephoneEmail = [
    {
        id: 0,
        description: '',
        id_telephone_type: 0,
        created_at: new Date(),
        updated_at: new Date(),
        status: 0,
    }
];
